import React, { Component, forwardRef } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { dataLocation, dataUser } from '../Helpers/util';
import dayjs from 'dayjs';
import AntDDatePicker from '../Common/AntDDateTimePicker/AntDDatePicker';
import { editformMember } from '../../Redux/action/memberAction';
import { grantAccess, grantAccess1 } from '../../Redux/action/memberAction';
import { allMember } from '../../Redux/action/memberAction';
import SwMultiSelect from '../Common/SwMultiSelect/SwMultiSelect';
import { toast } from 'react-toastify';
import axios from 'axios';
import Select from 'react-select';
import { onCityLocation } from '../../Redux/action/memberAction';
import axiosInstance from '../../utils/axiosInstance';
import {
  onBuildingLocation,
  onBuildingLocation1,
  onSPOCLocation,
} from '../../Redux/action/memberAction';
import { MultiSelect } from 'react-multi-select-component';
import { restrictEqualSign } from '../../Component/Helpers/util';
// import {Confirmation} from "../../Component/Popup/Confirmation";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import Modal from 'react-bootstrap/Modal';
import { property } from 'lodash';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
import SwInput from '../Common/FormComponent/SwInput';
import SwRadio from '../Common/FormComponent/SwRadio';
import SwTextArea from '../Common/FormComponent/SwTextArea';
import SwPhoneInput from '../Common/SwPhoneInput/SwPhoneInput';
import SwModal from '../Common/SwModal/SwModal';
import SwButton from '../Common/SwButtons/SwButtons';
import Accordion from 'react-bootstrap/Accordion';
import AntDUpload from '../Common/AntDUpload/AntDUpload';

// import { role } from "./role";
const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
var cityFname = { value: '', label: '' };
var buildingName = { value: '', label: '' };
var towername = { value: '', label: '' };
var floorName = { value: '', label: '' };
var editPhoneNumber = false;
const userDataLocal1 = dataLocation();
var LocationObj = JSON.parse(userDataLocal1);

class AddnewMember extends Component {
  constructor(props) {
    super(props);
    this.state = {
      decide: '1',
      prevPhoneNo: '',
      isValidPhoneNumber: true,
      modified_by: UserObj ? UserObj.rec_id : null,
      classDefalt: false,
      dataAdd: false,
      pgno: this.props.epg,
      row: this.props.erw,
      access_mr: false,
      access_vms: false,
      IsUserCheck: false,
      profile: {},
      fname: '',
      location_name: '',
      userRole: UserObj && UserObj.role_data ? UserObj.role_data : [],
      company_name: '',
      lname: '',
      email: '',
      locationSpoc: [],
      phone: '',
      is_active: null,
      dob: '',
      address: '',
      blood_group: '',
      emergency_contact: '',
      lastActivity: '',
      kyc_type: '',
      gender: '',
      payroll: '',
      project: '',
      designation: '',
      date_of_joining: '',
      specially_abled: '',
      userid: UserObj ? UserObj.rec_id : null,
      company_id: UserObj ? UserObj.company_id : null,
      kyc: {},
      rec_id: '',
      vaccinated: false,
      isSpocDrpdownShow: false,
      isGlobalCheckInOut: false,

      globalcheckin1: true,
      orgRole: [],
      role_id: false,
      roleValue: null,
      deptValue: null,
      dept_id: '',
      orgDept: [],
      location_id: '',
      user_role_id: null,
      roleErr: false,
      roleError: '',
      refreshCity: null,
      location_name: null,
      refreshFloor: null,
      buildingerrorMsg: '',
      spoc_location_erroeMsg: '',

      emp_code: '',
      items: {},
      selected: [],
      location: [],
      certificate: {},
      certificateFile: null,
      nfile: null,
      fileName: null,
      fileName1: null,
      frImageUrl: null,
      pendingFrImageUrl: null,
      showRejectFr: false,
      rejectFrReason: '',
      isSpoc: props.EditUserList?.activeEditData?.isSpoc || false,
      required: {
        cityName: true,
        buildingName: false,
      },
      ad: this.props.EditUserList.activeEditData,
      vaccinated: null,
      vaccinatedtype: [
        {
          // not vacinated
          vacType: false,
          vacFile: null,
          vacBase64: null,
          isActive: false,
        },
        {
          //single
          vacType: true,
          vacFile: null,
          vacBase64: null,
          isActive: false,
        },
      ],
      spoc_location: [],
      spoc_location_temp: [],

      showGrant: false,
      showRevoke: false,
      showDelUser: false,

      showDeny: false,
    };
  }

  // Method to handle closing the modal
  handleCloseGrant = () => {
    this.setState({ showGrant: false });
  };
  handleCloseRevoke = () => {
    this.setState({ showRevoke: false });
  };
  handleCloseDelUser = () => {
    this.setState({ showDelUser: false });
  };

  // Method to handle showing the modal
  handleShowGrant = () => {
    this.setState({ showGrant: true });
  };

  handleShowRevoke = () => {
    this.setState({ showRevoke: true });
  };

  handleShowDeny = () => {
    this.setState({ showDeny: true });
  };

  handleCloseDeny = () => {
    this.setState({ showDeny: false });
  };

  handleApproveFrImage = async () => {
    try {
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v2/user/face-update/${this.state.rec_id}/approve`,
        { rec_id: this.state.rec_id },
      );
      if (res.status === 200) {
        toast.success(res.data?.message || 'FR image approved successfully');
        this.setState({
          frImageUrl: this.state.pendingFrImageUrl,
          pendingFrImageUrl: null,
        });
        this.props.onSuccess && this.props.onSuccess();
      } else {
        toast.error(res.data?.message || 'Failed to approve FR image.');
      }
    } catch (error) {
      toast.error('An error occurred while approving the FR image.');
      console.error('Error approving FR image:', error);
    }
  };

  handleShowRejectFr = () => {
    this.setState({ showRejectFr: true, rejectFrReason: '' });
  };

  handleCloseRejectFr = () => {
    this.setState({ showRejectFr: false });
  };

  onRejectFrReasonChange = e => {
    this.setState({ rejectFrReason: e.target.value });
  };

  handleRejectFrImage = async () => {
    if (!this.state.rejectFrReason?.trim()) {
      toast.error('Please enter a rejection reason.');
      return;
    }
    try {
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v2/user/face-update/${this.state.rec_id}/reject`,
        {
          rejection_reason: this.state.rejectFrReason.trim(),
          rec_id: this.state.rec_id,
        },
      );
      if (res.status === 200) {
        toast.success(res.data?.message || 'FR image rejected successfully');
        this.setState({ pendingFrImageUrl: null, showRejectFr: false });
        this.props.onSuccess && this.props.onSuccess();
      } else {
        toast.error(res.data?.message || 'Failed to reject FR image.');
      }
    } catch (error) {
      toast.error('An error occurred while rejecting the FR image.');
      console.error('Error rejecting FR image:', error);
    }
  };

  bloodGroupOptions = [
    { value: 'A_NEGATIVE', label: 'A-' },
    { value: 'A_POSITIVE', label: 'A+' },
    { value: 'B_NEGATIVE', label: 'B-' },
    { value: 'B_POSITIVE', label: 'B+' },
    { value: 'AB_NEGATIVE', label: 'AB-' },
    { value: 'AB_POSITIVE', label: 'AB+' },
    { value: 'O_POSITIVE', label: 'O+' },
    { value: 'O_NEGATIVE', label: 'O-' },
  ];

  handleShowDelUser = () => {
    this.setState({ showDelUser: true });
  };

  componentDidMount = e => {
    // Fetch user roles
    let authToken = JSON.parse(localStorage.getItem('headData'));
    axios
      .get(
        `${process.env.REACT_APP_API_URL}userRoles/getRoleList/${
          this.state.company_id
        }`,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      )
      .then(response => {
        if (response.data && response.data.status === 'success') {
          const orgRoleWithSelect = [
            { role_name: 'Select' },
            ...response.data.data.result,
          ];
          this.setState({
            orgRole: orgRoleWithSelect,
          });
        }
      })
      .catch(err => {
        console.log('Error: ' + err);
      });

    // Fetch SPOC location data

    const params = {
      params: { spoc: UserObj.rec_id, client: UserObj.company_id },
      headers: {
        Authorization: authToken?.spintlyToken,
      },
    };
    axios
      .get(
        `${process.env.REACT_APP_API_URL}basic-data/get-location-by-spoc`,
        params,
      )
      .then(res => {
        if (res.data.status === 'success') {
          this.setState({
            locationSpoc: res.data.data,
          });
        }
      });
  };

  reload = e => {
    this.setState({
      fname: '',
      lname: '',
      email: '',
      phone: '',
      address: '',
      blood_group: '',
      gender: '',
      emergency_contact: '',
      kyc_type: '',
      rec_id: '',
      role: '',
      designation: '',
      certificate: null,
      certificateFile: null,
      refreshCity: null,
      location_name: null,
      refreshFloor: null,
      dept_id: '',
      company_name: '',
      selected: [],
      nfile: null,
      fileName1: null,
      emp_code: '',
      spoc_location_erroeMsg: '',
      isSpoc: '',
    });
    this.props.EditUserList.activeEditData = [];
  };

  removeClass = () => {
    this.setState({
      classDefalt: true,
    });
  };

  uploadImgfile2 = async event => {
    let convertBase64 = '';
    const fileReader = new FileReader();
    fileReader.readAsDataURL(event.target.files[0]);
    fileReader.onload = () => {
      convertBase64 = fileReader.result;
      const newState = this.state.vaccinatedtype.map(obj => {
        if (obj.isActive) {
          return {
            ...obj,
            vacFile: event.target.files[0].name,
            vacBase64: convertBase64,
          };
        }
        return obj;
      });

      this.setState({
        certificate: convertBase64,
        certificateFile: event.target.files[0].name,
        fileName: event.target.files[0].name,
        vaccinatedtype: newState,
      });
    };

    let formData = new FormData();
    formData.append('single_file', event.target.files[0]);
    axios
      .post(
        `${
          process.env.REACT_APP_API_URL
        }basic-data/single-img-upload?folder=vaccination_certificate`,
        formData,
      )
      .then(response => {
        if (response.data.statusValue == 200) {
          this.setState({ certificate: response.data.payload.fileData });
          toast.success(response.data.message);
        }
      });
  };

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.EditUserList.activeEditData?.email &&
      (this.props.EditUserList.activeEditData?.rec_id !==
        nextProps.EditUserList.activeEditData?.rec_id ||
        this.props.EditUserList.activeEditData?._editTimestamp !==
          nextProps.EditUserList.activeEditData?._editTimestamp)
    ) {
      const c_id = JSON.parse(localStorage.getItem('headData'));
      let parm2 = {
        user_id: c_id.company_id,
      };
      this.props.onSPOCLocation(parm2);
      if (nextProps.EditUserList.activeEditData != '') {

// 🔥 Vaccination File (for AntDUpload)
const vaccinatedFile =
  nextProps.EditUserList.activeEditData?.vaccinated_file;

const certificateFileList = vaccinatedFile
  ? [
      {
        uid: '-1',
        name: vaccinatedFile.split('/').pop(),
        status: 'done',
        url: vaccinatedFile,
      },
    ]
  : [];

// 🔥 KYC File (for AntDUpload)
const kycFile =
  nextProps.EditUserList.activeEditData?.kyc;

const kycFileList = kycFile
  ? [
      {
        uid: '-2',
        name: kycFile.split('/').pop(),
        status: 'done',
        url: kycFile,
      },
    ]
  : [];

        var selectedLocal = [];
        let locationTemp = [];
        nextProps.EditUserList.activeEditData.deptSpoc &&
          nextProps.EditUserList.activeEditData.deptSpoc.map((items, i) => {
            selectedLocal.push({
              value: parseInt(items.dept_id, 10),
              label: items.dept_name,
            });
            locationTemp.push(parseInt(items.dept_id, 10));
          });
        const newState1 = this.state.vaccinatedtype.map(obj => {
          if (obj.vacType == nextProps.EditUserList.activeEditData.vaccinated) {
            return {
              ...obj,
              isActive: true,
              vacFile: nextProps.EditUserList.activeEditData.vaccinated_file,
            };
          } else {
            return obj;
          }
        });

        // this.setState({
        //   vaccinatedtype: newState1,
        // });
        let tempSpoc = nextProps?.EditUserList?.activeEditData?.spoc_location
          ? nextProps.EditUserList.activeEditData.spoc_location?.map(
              (items, i) => {
                return items.loc_id;
              },
            )
          : [];
        let spoc_location_temp = nextProps?.EditUserList?.activeEditData
          ?.spoc_location
          ? nextProps.EditUserList.activeEditData.spoc_location?.map(
              (items, i) => {
                let newItem = {
                  value: items.loc_id,
                  label: items.location_name,
                };
                return newItem;
              },
            )
          : [];

        const now = new Date(
          nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData.date_of_joining,
        );

        const day = ('0' + now.getDate()).slice(-2);
        const month = ('0' + (now.getMonth() + 1)).slice(-2);
        const today =
          month == 'aN' || day == 'aN'
            ? ''
            : now.getFullYear() + '-' + month + '-' + day;

        const globalCheckin = () => {
          if (
            nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData.isGlobalCheckInOut == 1
          ) {
            return true;
          } else {
            return false;
          }
        };
        const customization =
          nextProps.EditUserList?.activeEditData?.coreUser
            ?.service_customization || {};
        const companyData = JSON.parse(localStorage.getItem('headData')) || {};
        const booking = companyData?.companyWiseBooking || {};
        this.setState({

certificateFileList: certificateFileList,
kycFileList: kycFileList,
          
          vaccinatedtype: newState1,
          fname:
            nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData.fname,
          emp_code:
            nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData.emp_code,
          location_name:
            nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData.location_name,
          company_name:
            nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData.company_name,
          lname:
            nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData.lname,
          email:
            nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData?.email,
          phone:
            nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData.phone,
          prevPhoneNo:
            nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData.phone,
          is_active:
            nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData.is_active,
          vaccinated:
            nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData.vaccinated,
          dob:
            nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData.dob,
          show_mr: booking.mr === true,
          show_vms: booking.vms === true,
          access_mr: customization.mr === true, // will set radio "Yes" checked
          access_vms: customization.vms === true,

          date_of_joining: today,
          project:
            nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData.project,
          gender:
            nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData.gender,
          isGlobalCheckInOut:
            nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData.isGlobalCheckInOut,

          // globalcheckin1: globalCheckin(),
          globalcheckin1: globalCheckin(),
          specially_abled:
            nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData.specially_abled,
          payroll:
            nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData.payroll,
          address:
            nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData.address,
          blood_group:
            nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData.blood_group,
          emergency_contact:
            nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData.emergency_contact,
          kyc_type:
            nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData.kyc_type,
          kyc:
            nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData.kyc,
          rec_id:
            nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData.rec_id,
          designation:
            nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData.designation,
          user_role_id:
            nextProps.EditUserList.activeEditData &&
            Number(nextProps.EditUserList.activeEditData.user_role_id),
          isSpoc: nextProps.EditUserList.activeEditData.isSpoc || false,
          role_id:
            nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData.user_role_id,
          dept_id:
            nextProps.EditUserList.activeEditData &&
            Number(nextProps.EditUserList.activeEditData.user_dept_id),
          location_id:
            nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData.location_id,
          refreshCity: nextProps.EditUserList.activeEditData && {
            label: nextProps.EditUserList.activeEditData.city_name,
            value: nextProps.EditUserList.activeEditData.city_id,
          },

          certificate:
            nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData.vaccinated_file,
          certificateFile:
            nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData.vaccinated_file,
          spoc_location_temp: spoc_location_temp,
          spoc_location: tempSpoc,
          city_id:
            nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData.city_id,
          // value: '6', label: 'Chennai'
          // {value: '6', label: 'Paras Downtown Centre, Golf Course Road, Gurugram'}
          location_name: nextProps.EditUserList.activeEditData && {
            value: nextProps.EditUserList.activeEditData.location_id,
            label: nextProps.EditUserList.activeEditData.location_name,
          },
          refreshFloor: nextProps.EditUserList.activeEditData && {
            label: nextProps.EditUserList.activeEditData.business_name,
            value: nextProps.EditUserList.activeEditData.business_id,
          },
          lastActivity:
            nextProps.EditUserList.activeEditData &&
            nextProps.EditUserList.activeEditData.lastActivity,
          selected: selectedLocal,
          location: locationTemp,
          // Current Image / FR Image for Approval both come from requestedFaceUpdate
          // on the existing user_details response (already fetched into activeEditData).
          frImageUrl:
            nextProps.EditUserList.activeEditData?.requestedFaceUpdate
              ?.previous_img_url || null,
          pendingFrImageUrl:
            nextProps.EditUserList.activeEditData?.requestedFaceUpdate
              ?.staged_img_url || null,
        });

        setTimeout(() => {
          this.getDepDataByLocation(this.state.spoc_location);
        }, 500);
      }
    }

    if (
      this.state.dataAdd == true &&
      nextProps.ActiveDataUPload &&
      nextProps.ActiveDataUPload.data &&
      nextProps.ActiveDataUPload.data.status == 200
    ) {
      this.setState({
        dataAdd: false,
      });
      let param = {
        pgno: this.props.epg,
        row: this.state.row,
        company_id: this.state.company_id,
      };

      this.props.allMember(param);
    }
  }

  convertBase64 = file => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = error => {
        reject(error);
      };
    });
  };

  // handelMultySelect = e => {
  //   e.map(items => {
  //     this.list.add(parseInt(items.value));
  //   });
  //   this.setState({
  //     selected: e,
  //     location: Array.from(this.list),
  //   });
  // };

  handelMultySelect = e => {
    var list = new Set();
    e.map(items => {
      list.add(parseInt(items.value));
      // list.add({ dept_id: items.value, dept_name: items.label });
    });
    this.setState({
      selected: e,
      // location: Array.from(list),
      deptSpoc: Array.from(list),
    });
  };

  handelMultyBuildingSelect = e => {
    var list = [];
    e.map(items => {
      list.push(parseInt(items.value));
      // list.add({ dept_id: items.value, dept_name: items.label });
    });
    this.setState({
      spoc_location_temp: e,
      spoc_location: list,
      spoc_location_erroeMsg: '',
      selected: [],
    });
    this.getDepDataByLocation(list);
  };

  uploadImg = async event => {
    let convertBase64 = '';
    const fileReader = new FileReader();
    fileReader.readAsDataURL(event.target.files[0]);
    fileReader.onload = () => {
      convertBase64 = fileReader.result;
      this.setState({
        profile: convertBase64,
        nfile: URL.createObjectURL(event.target.files[0]),
      });
    };
    let formData = new FormData();
    formData.append('single_file', event.target.files[0]);
    axios
      .post(
        `${
          process.env.REACT_APP_API_URL
        }basic-data/single-img-upload?folder=app_profile`,
        formData,
      )
      .then(response => {
        if (response.data.statusValue == 200) {
          this.setState({ profile: response.data.payload.fileData });
          toast.success(response.data.message);
        }
      });
  };

  uploadImgfile = async event => {
    let convertBase64 = '';
    const fileReader = new FileReader();
    fileReader.readAsDataURL(event.target.files[0]);
    fileReader.onload = () => {
      convertBase64 = fileReader.result;
      this.setState({
        kyc: convertBase64,
        fileName1: event.target.files[0].name,
      });

      let formData = new FormData();
      formData.append('single_file', event.target.files[0]);
      axios
        .post(
          `${
            process.env.REACT_APP_API_URL
          }basic-data/single-img-upload?folder=kyc_proof`,
          formData,
        )
        .then(response => {
          if (response.data.statusValue == 200) {
            this.setState({ kyc: response.data.payload.fileData });
            toast.success(response.data.message);
          }
        });
    };
  };

  getDepDataByLocation = (loc_id = '') => {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    let locId = loc_id;
    if (locId == '') locId = this.state.location_id;
    axios
      .get(
        `${process.env.REACT_APP_API_URL}department/getActiveDepartment/${
          this.state.company_id
        }/${locId}`,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      )
      .then(response => {
        if (response.data && response.data.status == 'success') {
          response.data.data.activeDepartment.unshift({
            id: '',
            dept_name: 'Select',
          });
          this.setState({
            orgDept: response.data.data.activeDepartment,
          });
        }
      })
      .catch(err => {
        console.log('Error: ' + err);
      });
  };

  EditMemeberHandler = e => {
    this.setState({
      [e.target.name]: e.target.value,
      fnameerrorMsg: '',
      // lnameerrorMsg: '',
      phone_noerrorMsg: '',
      email_iderrorMsg: '',
    });
  };

  handlePhoneNumberChange = value => {
    this.setState({
      phone: value,
      phone_noerrorMsg: '', // clear error when typing
    });
  };

  getRoleOptions = () => {
    return this.state.orgRole
      .filter(role => role.role_name?.toLowerCase() !== 'select')
      .map(role => ({
        value: Number(role.id), // ensure number
        label: role.role_name,
      }));
  };
  validatePhoneNumber = value => {
    // Validate Indian phone numbers with country code '91' and 10-digit mobile number
    const phoneRegex = /^91[6-9]\d{9}$/;

    return phoneRegex.test(value);
  };

  validateOtherPhoneNumber = value => {
    const phoneRegex = /^\d{8,14}$/;
    return phoneRegex.test(value);
  };

  EditMemeberHandlerEmpCode = e => {
    this.setState({
      [e.target.name]: e.target.value.replace(/[^\w\s]/gi, ''),
      fnameerrorMsg: '',
      // lnameerrorMsg: '',
      phone_noerrorMsg: '',
      email_iderrorMsg: '',
    });
  };

  changeBldGroup = selectedOption => {
    this.setState({
      blood_group: selectedOption ? selectedOption.value : null,
    });
  };
  kycOptions = [
    { value: 'AADHAR', label: 'Aadhar' },
    { value: 'PAN', label: 'PAN' },
    { value: 'PASSPORT', label: 'Passport' },
    { value: 'VOTERID', label: 'Voter Identity Card' },
    { value: 'NREGA', label: 'NREGA Card' },
    { value: 'DL', label: 'Driving License' },
  ];

  changeKycType = selectedOption => {
    this.setState(prevState => ({
      kyc_type: selectedOption ? selectedOption.value : null,
      dis: !prevState.dis,
    }));
  };

  onChangeValue = event => {
    // When 'No' is selected (vaccinated === false), clear the certificateFile and certificate state
    if (event.target.value === 'false') {
      this.setState({
        certificateFile: '', // Clear certificateFile when 'No' is selected
        certificate: '', // Clear certificate (if required)
      });
    }

    // Update the vaccinatedtype array based on the selected radio button value
    const newVaccinatedType = this.state.vaccinatedtype.map(obj => {
      if (obj.vacType === event.target.value) {
        return {
          ...obj,
          isActive: true, // Mark the selected type as active
        };
      } else {
        return {
          ...obj,
          isActive: false, // Deactivate the other types
        };
      }
    });

    // Update state with the selected radio button value, vaccinatedtype, and clear error message if needed
    this.setState({
      vaccinatedtype: newVaccinatedType,
      [event.target.name]: event.target.value === 'true', // Ensure vaccinated is boolean (true or false)
      ...(event.target.value !== '' && {
        [`${event.target.name}errorMsg`]: '', // Clear error message
      }),
    });
  };

  changeRole = e => {
    this.setState({
      [e.target.name]: e.target.value,
      roleError: '',
    });
  };
  changeDept = selectedOption => {
    this.setState({
      dept_id: selectedOption ? selectedOption.value : null,
    });
  };

  handleSpocRadio = e => {
    const value = JSON.parse(e.target.value);
    // Convert "true"/"false" string to boolean

    if (value === true) {
      this.setState({
        role_id: true,
        roleErr: true,
      });
    } else {
      this.setState({
        role_id: false,
        roleErr: false,
        roleError: '',
        user_role_id: '',
        location: [],
        spoc_location: [],
      });
    }
    this.setState({ isSpoc: value });
  };

  handleRadioChange = e => {
    const value = parseInt(e.target.value, 10); // Get the binary value (1 or 0)
    this.setState({
      isGlobalCheckInOut: value,
    });
  };

  handleChange4 = city => {
    var required = this.state.required;
    required.buildingName = true;
    let parm1 = {
      cityid: city.value,
    };
    this.setState({
      city: city?.value,
      refreshCity: city,
      required: required,

      location_name: {
        value: '',
        label: 'Please select',
        cityerrorMsg: null,
      },
      refreshFloor: {
        value: '',
        label: 'Please select',
        buildingerrorMsg: '',
      },
    });
    let parm = {
      spoc: this.state.userid,
      client: this.state.company_id,
      city: city?.value,
    };
    this.setState({ city_id: city.value, refreshCity: city });
    this.props.onCityLocation(parm1);
    this.props.onBuildingLocation1(parm);
    this.state.location_name = null;
  };


  

  buildingChangeEvent = buildingid => {
    let parm = {
      buildingid: buildingid.value,
    };
    this.setState({
      refreshFloor: {
        value: '',
        label: 'Please select',
      },
      buildingerrorMsg: '',
    });
    this.setState({
      location_id: buildingid.value,
      location_name: buildingid,
    });
    this.props.onBuildingLocation(parm);
    this.getDepDataByLocation(buildingid.value);
  };

  handleChange = (val, name) => {
    this.setState({
      business_id: val.value,
      refreshFloor: val,
      cityerrorMsg: null,
      floorerrorMsg: '',
    });
  };

  sendId(items, i) {
    this.setState({
      tower_id: items.tower_id,
      floor_id: items.floor_id,
      city_name: items.city_id,
      setIndex: i,
      floorName: items.floor_name,
      // cityName:[{value:0, label:items.city_name}],
      buildingName: items.building_name,
      towername: items.tower_name,
    });

    cityFname.label = items.city_name;
    buildingName.label = items.building_name;
    towername.label = items.tower_name;
    floorName.label = items.floor_name;
  }

  GrantAccess = e => {
    e.preventDefault();

    // Extract necessary data for the API call

    const rec_id = this.props.EditUserList.activeEditData.rec_id; // Get `rec_id` (user ID)

    if (!rec_id) {
      console.error('rec_id is missing. Cannot grant access.');
      return;
    }

    // Prepare the parameters
    const params = {
      rec_id, // Include `rec_id` in the params
    };

    // Dispatch the `grantAccess` action
    this.props.grantAccess(params);
    this.setState({ showGrant: false });
  };

  DenyRequest = e => {
    e.preventDefault();

    // Extract necessary data for the API call

    const rec_id = this.props.EditUserList.activeEditData.rec_id; // Get `rec_id` (user ID)

    if (!rec_id) {
      console.error('rec_id is missing. Cannot grant access.');
      return;
    }

    // Prepare the parameters
    const params = {
      rec_id, // Include `rec_id` in the params
    };

    // Dispatch the `grantAccess` action
    this.props.grantAccess1(params);
    this.setState({ showRevoke: false });
  };

  extractSpecificKeys = data => {
    const {
      fname,
      lname,
      dept_id,
      phone,
      email,
      is_active,
      isGlobalCheckInOut,
      globalcheckin1,
      dob,
      address,
      vaccinated,
      blood_group,
      emergency_contact,
      // kyc_type,
      // kyc_file,
      gender,
      specially_abled,
      emp_code,
      date_of_joining,
      designation,
      payroll,
      project,
      business_name,
      city_name,
      location_name,
      refreshCity,
      refreshFloor,
      location_id,
      user_role_id,
      // spoc_location_temp,
      spoc_location,
      selected,
      deptSpoc,
      certificateFile,
      certificate,
      vaccinatedtype,
      kyc_type,
      nfile,
      fileName1,
      isSpoc,
    } = data;
    return {
      fname,
      lname,
      emp_code,
      phone,
      email,
      // location_name,
      is_active,
      isGlobalCheckInOut,
      globalcheckin1,
      dob,
      address,
      vaccinated,
      blood_group,
      emergency_contact,
      // kyc_type,
      // kyc_file,
      gender,
      specially_abled,
      date_of_joining,
      designation,
      payroll,
      project,
      // location_name,
      // city_name
      // globalcheckin1
      property_id: location_id,
      user_dept_id: dept_id,
      spoc_location,
      // location_name,
      // city_name: refreshCity ? refreshCity.label : undefined, // Mapping refreshCity to city_name
      // business_name: refreshFloor ? refreshFloor.label : undefined,
      user_role_id,
      selected,
      deptSpoc,
      certificateFile,
      certificate,
      vaccinatedtype,
      kyc_type,
      kyc_file: fileName1,
      profile_img_url: nfile,
      isSpoc,
      access_mr: data.access_mr,
      access_vms: data.access_vms,
    };
  };

  getUpdatedFields = () => {
    const { state } = this; // updated state
    const { EditUserList } = this.props;
    const activeEditData = EditUserList.activeEditData || {};
    // original data
    const extractedState = this.extractSpecificKeys(state);
    const extractedActiveEditData = this.extractSpecificKeys(activeEditData);

    // Compare state with activeEditData and exclude unchanged fields or empty fields
    return Object.keys(extractedState).reduce((updatedFields, key) => {
      // Check if the values have changed, and that they are not empty (arrays, null, etc.)
      const currentValue = extractedState[key];
      const previousValue = extractedActiveEditData[key];

      if (currentValue !== previousValue) {
        // For empty arrays or null, ensure they're only added if they have changed
        if (
          currentValue !== undefined &&
          !(Array.isArray(currentValue) && currentValue.length === 0) &&
          currentValue !== null
        ) {
          updatedFields[key] = currentValue;
        }
      }

      return updatedFields;
    }, {});
  };

  EditSubmit = e => {
    const updatedFields = this.getUpdatedFields();

    e.preventDefault();

    if (Object.keys(updatedFields).length > 0) {
      const {
        fname,
        lname,
        user_dept_id,
        email,
        phone,
        spoc_location,
        is_active,
        isGlobalCheckInOut,
        globalcheckin1,
        dob,
        address,
        blood_group,
        emergency_contact,
        gender,
        specially_abled,
        date_of_joining,
        designation,
        payroll,
        project,
        property_id,
        user_role_id,
        vaccinated,
        selected,
        deptSpoc,
        certificateFile,
        certificate,
        vaccinatedtype,
        kyc_type,
        kyc_file,
        isSpoc,
        emp_code,
        access_vms,
        access_mr,
      } = updatedFields;
      const companyData = JSON.parse(localStorage.getItem('headData'));

      const isMrEnable =
        companyData?.companyWiseBooking?.mr === true ? true : false;
      const isVMSEnable =
        companyData?.companyWiseBooking?.vms === true ? true : false;

      const payloadObject = {
        fname,
        lname,
        // Send "" when the employee code is cleared so the backend stores a
        // blank value and the field shows empty on next edit.
        emp_code:
          emp_code === undefined
            ? undefined
            : emp_code.trim() === ''
            ? ''
            : emp_code,
        email,
        ...(phone !== undefined && { phone: phone?.replace(/^\+/, '') }),
        spoc_location,
        user_dept_id,
        rec_id: this.state.rec_id,
        isGlobalCheckInOut,
        dob,
        address,
        blood_group,
        emergency_contact,
        gender,
        specially_abled,
        date_of_joining,
        designation,
        payroll,
        project,
        property_id,
        user_role_id,
        selected,
        deptSpoc,
        kyc_type,
        kyc_file: this.state.fileName1,
        profile_img_url: this.state.nfile || updatedFields.profile_img_url,
        isSpoc: this.state.isSpoc,
        ...((isMrEnable || isVMSEnable) && {
          service_customization: {
            ...(isMrEnable && { mr: access_mr }),
            ...(isVMSEnable && { vms: access_vms }),
          },
        }),
      };

      // ✅ ADD THIS BLOCK HERE

      // const companyData = JSON.parse(localStorage.getItem('headData')) || {};
      // const booking = companyData?.companyWiseBooking || {};

      // const service_customization = {};

      // if (booking.mr === true) {
      //   service_customization.mr = this.state.access_mr === true;
      // }

      // if (booking.vms === true) {
      //   service_customization.vms = this.state.access_vms === true;
      // }

      // if (Object.keys(service_customization).length > 0) {
      //   payloadObject.service_customization = service_customization;
      // }

      // ✅ Submit to API
      this.props.editformMember(payloadObject);
    } else {
    }
  };

  changeGender = e => {
    this.setState({
      // [e.target.name]: e.target.value,
      gender: e.target.value,
    });
  };

  speciallyAbledOptions = [
    { value: true, label: 'Yes' },
    { value: false, label: 'No' },
  ];

  getDeptOptions = () => {
    return this.state.orgDept
      .filter(dept => dept.dept_name.toLowerCase() !== 'select') // skip placeholder
      .map(dept => ({
        value: dept.id,
        label: dept.dept_name,
      }));
  };

  changespecAbled = selectedOption => {
    this.setState({
      specially_abled: selectedOption ? selectedOption.value : null,
    });
  };
  handleChangeComapny = (field, value) => {
    this.setState({ [field]: value });
  };

  addMemeberHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  deleteUser = async () => {
    let userId = this.props.EditUserList.activeEditData.rec_id;

    try {
      // Retrieve organization data from localStorage
      const organizationData = JSON.parse(localStorage.getItem('headData'));
      if (!organizationData) {
        toast.error('Organization data not found in local storage.');
        return;
      }

      // Make the DELETE API call
      const res = await axiosInstance.delete(
        `${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v2/user/${userId}`,
        {
          headers: {
            'req-organization-id': organizationData.organizationId,
            'req-organization-type': organizationData.roomShared,
          },
        },
      );

      // Handle successful response
      if (res.status === 200) {
        toast.success(res.data.message, {});
        this.handleCloseDelUser();
        setTimeout(() => {
          window.location.reload();
        }, 500);
      } else {
        toast.error(res.data.message, {});
      }
    } catch (error) {
      // Error handling
      toast.error('An error occurred while deleting the user.');
      console.error('Error deleting user:', error);
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.onFooterState) {
      const isApproved = this.props.EditUserList.activeEditData?.isSpocApproved;

      const isApproved1 =
        this.props.EditUserList.activeEditData?.is_active || 0;

      const ManageApproval1 = this.state.userRole.find(
        element => element.service_id == '23',
      );

      const ManageMembers = this.state.userRole.find(
        element => element.service_id == '1',
      );

      this.props.onFooterState({
        isApproved,
        isApproved1,
        ManageApproval1,
        ManageMembers,
        btnStatus: this.state.btnStatus,
      });
    }
  }

  // setTimeout(() => {
  //   window.location.reload();
  // }, 1000);
  render() {
    const { showGrant } = this.state; // Destructure state for readability
    const { showRevoke } = this.state; // Destructure state for readability
    const { showDelUser } = this.state;
    const { showDeny } = this.state;
    // Destructure state for readability

    const { popUp } = this.props;
    const EditMember = this.props.EditUserList.activeEditData;
    const isApproved = this.props.EditUserList.activeEditData?.isSpocApproved;

    const isApproved1 = this.props.EditUserList.activeEditData?.is_active
      ? this.props.EditUserList.activeEditData?.is_active
      : 0;

    const newMember = this.props.newMemberData.NewMemberData;
    const BuildingData = this.props.CityData.BuildingData;
    const NewCity = this.props.CityData1.CityData1;
    const BuildingNams = this.props.buildingInfo;
    const BuildingSPOCNames = this.props?.BuildingSPOCData
      ? this.props.BuildingSPOCData
      : [];

    const optionsCity = [];

    if (NewCity !== 0) {
      NewCity &&
        NewCity.map((items, i) => {
          optionsCity.push({ value: items.city_id, label: items.city_name });
        });
    }
    const options4 = [];
    if (newMember !== 0) {
      newMember &&
        newMember.map((items, i) => {
          options4.push({ value: items.rec_id, label: items.city_name });
        });
    }

    const options7 = [];

    this.state.orgDept.map(dept => {
      if (dept.dept_name != 'Select') {
        options7.push({ value: dept.id, label: dept.dept_name });
      }
    });

    const floorNames = [];
    if (BuildingData !== 0) {
      BuildingData &&
        BuildingData.map((items, i) => {
          floorNames.push({
            value: items.rec_id,
            label: items.business_name,
          });
        });
    }

    const buildingNmaes = [];
    if (BuildingNams !== 0) {
      BuildingNams &&
        BuildingNams.map((items, i) => {
          buildingNmaes.push({
            value: items.rec_id,
            label: items.location_name,
          });
        });
    }

    const buildingNamesSPOC = [];
    if (this.state.locationSpoc !== 0) {
      this.state.locationSpoc &&
        this.state.locationSpoc.map((items, i) => {
          buildingNamesSPOC.push({
            value: items.rec_id,
            label: items.location_name,
          });
        });
    }

    const ManageApproval1 = this.state.userRole.find(
      element => element.service_id == '23',
    );

    const attendenceSiftAssign = this.state.userRole.find(
      element => element.service_id == '25',
    );
    const ManageMembers = this.state.userRole.find(
      element => element.service_id == '1',
    );
    const footerState = {
      isApproved1,
      isApproved,
      ManageApproval1,
      ManageMembers,
      btnStatus: this.state.btnStatus,
    };
    const roleOptions = this.getRoleOptions();
    const selectedRole = roleOptions.find(
      option => option.value == this.state.user_role_id,
    );

    return (
      <>

        



      <Accordion
        defaultActiveKey={['0', '1', '2']}
        alwaysOpen
        className="SwAccordionV2 NoBorder SwAccordionV2-sm"
      >

        {/* ─────────────────────────────────────────────── */}
        {/* BASIC DETAILS                                     */}
        {/* ─────────────────────────────────────────────── */}
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <i className="bi bi-person me-2" />
            Basic Details
          </Accordion.Header>
          <Accordion.Body>

            <div className="row mb-4">
              <div className="col-12">
                <div className="d-flex gap-4 flex-wrap align-items-start">
                  <div>
                    <label className="SwFormLabel d-block mb-1">
                      Profile Image
                    </label>
                    <div className="EditMemberProfileImg">
                      <img
                        src={
                          this.state.nfile
                            ? this.state.nfile
                            : (EditMember &&
                                EditMember?.profile_img_url &&
                                EditMember?.profile_img_url == 'no_image.jpg') ||
                              EditMember?.profile_img_url == '' ||
                              EditMember?.profile_img_url == null
                            ? 'https://smartworks-production.s3-ap-southeast-1.amazonaws.com/app_profile/profile.png'
                            : EditMember?.profile_img_url
                        }
                        alt="Profile"
                      />
                      <label className="EditMemberCameraBadge" title="Change photo">
                        <input
                          type="file"
                          className="d-none"
                          onChange={e => {
                            this.uploadImg(e);
                          }}
                        />
                        <i className="bi bi-camera-fill" />
                      </label>
                    </div>
                    <span className="SwTextDanger SwTextSmall d-block">
                      {this.state.nfileerrorMsg}
                    </span>
                    {EditMember?.profile_img_url ? (
                      <div>
                        <div
                          onClick={() => {
                            let url = `${process.env.REACT_APP_API_URL
                              }user/download_user_image`;
                            fetch(
                              `${url}?image_url=${JSON.stringify(
                                EditMember?.profile_img_url,
                              )}`,
                              {
                                // mode : 'no-cors',
                                // method: 'POST',
                                // body: JSON.stringify({
                                //   "image_url": `https://react-cn.github.io/react/img/logo.svg`,
                                // })
                              },
                            )
                              .then(response => response.blob())
                              .then(blob => {
                                let blobUrl = window.URL.createObjectURL(
                                  blob,
                                );
                                let a = document.createElement('a');
                                a.download = EditMember?.profile_img_url.replace(
                                  /^.*[\\\/]/,
                                  '',
                                );
                                a.href = blobUrl;
                                document.body.appendChild(a);
                                a.click();
                                a.remove();
                              });
                          }}
                        >
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>

                  {this.state.frImageUrl || this.state.pendingFrImageUrl ? (
                    <div className="EditMemberVDivider" />
                  ) : (
                    ''
                  )}

                  {this.state.frImageUrl ? (
                    <div className="SwFormGroup mb-0">
                      <label className="SwFormLabel d-block mb-1">
                        Current Image
                      </label>
                      <div className="EditMemberFrBox active">
                        <img src={this.state.frImageUrl} alt="Current FR" />
                        <span className="EditMemberFrBadge">
                          <i className="bi bi-check-lg" />
                        </span>
                      </div>
                    </div>
                  ) : (
                    ''
                  )}

                  {this.state.pendingFrImageUrl ? (
                    <div className="SwFormGroup mb-0">
                      <label className="SwFormLabel d-block mb-1">
                        FR Image for Approval
                      </label>
                      <div className="EditMemberFrBox">
                        <img
                          src={this.state.pendingFrImageUrl}
                          alt="Pending FR"
                        />
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                </div>

                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-3">
                  {isApproved1 == 1 && isApproved == 1 ? (
                    <div>
                      <div className="btn-group">
                        <a
                          type="button"
                          className="btn btn-secondary dropdown-toggle edit_popup_dd1  "
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                            Access
                        </a>
                        <div className="dropdown-menu dropdown-menu-right">
                          <button
                            disabled={
                              ManageApproval1 &&
                              ManageApproval1.role_for_write != '1'
                            }
                            className="dropdown-item"
                            type="button"
                            onClick={this.handleShowRevoke}
                          >
                            Revoke access
                          </button>
                          <button
                            disabled={
                              ManageApproval1 &&
                              ManageApproval1.role_for_write != '1'
                            }
                            className="dropdown-item"
                            type="button"
                            onClick={this.handleShowDelUser}
                          >
                            Remove User
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : (isApproved1 == 1 && isApproved == 2) ||
                    (isApproved1 == 0 && isApproved == 0) ||
                    (isApproved1 == 0 && isApproved == 1) ||
                    (isApproved1 == 0 && isApproved == 2) ? (
                    <div>
                      <div className="btn-group">
                        <a
                          type="button"
                          className="btn btn-secondary dropdown-toggle edit_popup_dd1"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-three-dots ToHideMobile"
                            viewBox="0 0 16 16"
                          >
                            <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                          </svg>
                          <span className="MemberAccessMobileEditBTN">
                            Access
                          </span>
                        </a>
                        <div className="dropdown-menu dropdown-menu-right">
                          <button
                            disabled={
                              ManageApproval1 &&
                              ManageApproval1.role_for_write != '1'
                            }
                            className="dropdown-item"
                            type="button"
                            onClick={this.handleShowGrant}
                          >
                            Grant access
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div />
                  )}

                  {this.state.pendingFrImageUrl ? (
                    <div className="d-flex gap-2">
                      <SwButton
                        variant="primary"
                        size="sm"
                        className="EditMemberFrApproveBtn"
                        onClick={this.handleApproveFrImage}
                      >
                        <i className="bi bi-check-lg me-1" />
                        Approve
                      </SwButton>
                      <SwButton
                        variant="danger-outline"
                        size="sm"
                        onClick={this.handleShowRejectFr}
                      >
                        <i className="bi bi-x-lg me-1" />
                        Reject
                      </SwButton>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 col-xs-12 col-sm-6">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">
                    First Name
                    <span className="Required">*</span>
                  </label>

                  <SwInput
                    type="text"
                    name="fname"
                    value={this.state.fname}
                    onChange={this.EditMemeberHandler}
                    onKeyPress={restrictEqualSign}
                    placeholder="First Name"
                  />

                  {this.state.fnameerrorMsg && (
                    <span className="SwTextDanger SwTextSmall">
                      {this.state.fnameerrorMsg}
                    </span>
                  )}
                </div>
              </div>
              <div className="col-md-6 col-xs-12 col-sm-6">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">Last Name</label>

                  <SwInput
                    type="text"
                    name="lname"
                    value={this.state.lname}
                    onChange={this.EditMemeberHandler}
                    onKeyPress={restrictEqualSign}
                    placeholder="Last Name"
                  />
                </div>
              </div>
            </div>
            <div className="row ToHideMobile">
              <div className="col-md-12 col-xl-12 col-lg-12">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">Employee Code</label>

                  <SwInput
                    type="text"
                    name="emp_code"
                    value={this.state.emp_code}
                    onChange={this.EditMemeberHandlerEmpCode}
                    placeholder="Employee Code"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                
                <div className="SwFormGroup">
                  <label className="SwFormLabel">Mobile Number*</label>
                  <SwPhoneInput
                    country="in"
                    value={this.state.phone}
                    onChange={this.handlePhoneNumberChange}
                    enableSearch
                    error={!!this.state.phone_noerrorMsg}
                    errorMsg={this.state.phone_noerrorMsg}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">
                    Corporate Email <span className="Required">*</span>
                  </label>

                  <SwInput
                    type="text"
                    name="email"
                    value={this.state.email}
                    onChange={this.EditMemeberHandler}
                    placeholder="Corporate Email"
                    readOnly
                    onKeyPress={restrictEqualSign}
                  />

                  <span className="SwTextDanger SwTextSmall">
                    {this.state.email_iderrorMsg}
                  </span>
                </div>
              </div>
            </div>

            {/* </div> */}
            <div className="row ToHideMobile">
              <div className="col-md-6 col-xs-12 col-sm-6">
                <div className="formAddmemGrid" />
              </div>
            </div>

            <div className="row ToHideMobile">
              <div class="col-md-12 col-xl-12 col-lg-12">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">
                    City <span className="Required">*</span>
                  </label>

                  <SwSelect
                    value={this.state.refreshCity}
                    onChange={this.handleChange4}
                    options={options4}
                    placeholder="Select City"
                    isClearable={false}
                  />
                </div>
                <span className="SwTextDanger SwTextSmall">
                  {this.state.cityerrorMsg}
                </span>
              </div>
            </div>
            <div className="row ToHideMobile">
              <div className="col-md-12 col-xl-12 col-lg-12">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">
                    Building Name <span className="Required">*</span>
                  </label>

                  <SwSelect
                    value={this.state.location_name}
                    onChange={this.buildingChangeEvent}
                    options={buildingNmaes}
                    placeholder="Select Building"
                    isClearable={false}
                  />
                </div>
                <span className="SwTextDanger SwTextSmall">
                  {this.state.buildingerrorMsg}
                </span>
              </div>
            </div>
            <div className="row ToHideMobile">
              <div className="col-md-12 col-xl-12 col-lg-12">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">
                    Floor <span className="Required">*</span>
                  </label>

                  <SwSelect
                    value={this.state.refreshFloor}
                    onChange={this.handleChange}
                    options={floorNames}
                    placeholder="Select Floor"
                    isClearable={false}
                  />
                </div>
                <span className="SwTextDanger SwTextSmall">
                  {this.state.floorerrorMsg}
                </span>
              </div>
            </div>
            <div className="row ToHideMobile">
              <div className="col-lg-12 col-md-6 col-xs-12 col-sm-12">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">
                    Employee Department
                  </label>

                  <SwSelect
                    options={this.getDeptOptions()}
                    value={
                      this.getDeptOptions().find(
                        option => option.value === this.state.dept_id,
                      ) || null
                    }
                    onChange={this.changeDept}
                    placeholder="Select Department"
                    isClearable={false}
                  />
                </div>
              </div>
            </div>
            <div className="row ToHideMobile">
              <div className="col-md-12 col-xs-12 col-sm-12">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">
                    Company Name <span className="Required">*</span>
                  </label>

                  <SwInput
                    type="text"
                    name="company_name"
                    value={this.state.company_name}
                    onChange={this.EditMemeberHandler}
                    placeholder="Company Name"
                    readOnly
                  />
                </div>
                <div className="row">
                  <div className="col-md-6 col-xs-12 col-sm-6">
                    <div className="SwFormGroup">
                      <label className="SwFormLabel">
                        Spoc <span className="Required">*</span>
                      </label>

                      <div>
                        <SwRadio
                          id="spocYes"
                          name="spoc"
                          label="Yes"
                          value={true}
                          checked={this.state.isSpoc === true}
                          onChange={this.handleSpocRadio}
                          inline
                        />
                        <SwRadio
                          id="spocNo"
                          name="spoc"
                          label="No"
                          value={false}
                          checked={this.state.isSpoc === false}
                          onChange={this.handleSpocRadio}
                          inline
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
                
          </Accordion.Body>
        </Accordion.Item>



        {/* ??? */}
        <div>
          <div className="row ToHideMobile">
            {this.state.isSpoc === true && (
              <div className="col-md-6 col-lg-12">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">
                    Role <span className="Required">*</span>
                  </label>

                  <SwSelect
                    options={roleOptions}
                    value={selectedRole || null}
                    onChange={selectedOption =>
                      this.setState({
                        user_role_id: selectedOption?.value || '',
                        roleError: '',
                      })
                    }
                    placeholder="Select Role"
                    isClearable={false}
                  />

                  <span className="SwTextDanger SwTextSmall">
                    {this.state.roleError}
                  </span>
                </div>
              </div>
            )}
          </div>

          <div className="row ToHideMobile">
            {this.state.isSpoc === true && (
              <div className="col-md-6 col-lg-12">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">
                    Location Names<span className="ixon">*</span>
                  </label>

                  <SwMultiSelect
                    options={buildingNamesSPOC}
                    value={this.state.spoc_location_temp}
                    onChange={this.handelMultyBuildingSelect}
                    labelledBy="Select"
                  />

                  <span className="SwTextDanger SwTextSmall">
                    {this.state.spoc_location_erroeMsg}
                  </span>
                </div>
              </div>
            )}
          </div>
          <div className="row ToHideMobile">
            {this.state.isSpoc === true && (
              <div className="col-md-6 col-lg-12">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">SPOC Department</label>

                  <SwMultiSelect
                    options={options7}
                    value={this.state.selected}
                    onChange={this.handelMultySelect}
                    labelledBy="Select"
                  />
                </div>
              </div>
            )}
          </div>

          {attendenceSiftAssign &&
          attendenceSiftAssign.role_for_write == '1' ? (
            <div className="row ToHideMobile">
              <div className="col-md-6 col-xs-12 col-sm-6">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">Global Checkin</label>

                  <div>
                    <SwRadio
                      id="globalCheckinYes"
                      name="globalCheckin"
                      label="Yes"
                      value={1}
                      checked={this.state.isGlobalCheckInOut === 1}
                      onChange={this.handleRadioChange}
                      inline
                    />
                    <SwRadio
                      id="globalCheckinNo"
                      name="globalCheckin"
                      label="No"
                      value={0}
                      checked={this.state.isGlobalCheckInOut === 0}
                      onChange={this.handleRadioChange}
                      inline
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
        </div>




        {/* ─────────────────────────────────────────────── */}
        {/* ACCESS PERMISSIONS                                */}
        {/* ─────────────────────────────────────────────── */}
        {(this.state.show_mr || this.state.show_vms) && (
          <Accordion.Item eventKey="1">
            <Accordion.Header>Access permissions</Accordion.Header>
            <Accordion.Body>
              
                <p className="collapseAccessPermission_Info">
                  Set specific access for this user. You can edit it anytime
                  later.
                </p>

                <div className="ml-2">
                  {this.state.show_mr && (
                    <div className="SwFormGroup">
                      <label className="SwFormLabel">Meeting Room</label>
                      <div>
                        <div className="custom-control custom-radio custom-control-inline">
                          <input
                            type="radio"
                            id="meeting-button-1"
                            name="mr"
                            className="custom-control-input"
                            value="true"
                            checked={this.state.access_mr === true}
                            onChange={() =>
                              this.handleChangeComapny('access_mr', true)
                            }
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="meeting-button-1"
                          >
                            Yes
                          </label>
                        </div>
                        <div className="custom-control custom-radio custom-control-inline">
                          <input
                            type="radio"
                            id="meeting-button-2"
                            name="mr"
                            className="custom-control-input"
                            value="false"
                            checked={this.state.access_mr === false}
                            onChange={() =>
                              this.handleChangeComapny('access_mr', false)
                            }
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="meeting-button-2"
                          >
                            No
                          </label>
                        </div>
                      </div>
                    </div>
                  )}

                  {this.state.show_vms && (
                    <div className="formAddmemGrid">
                      <label className="d-block">VMS</label>
                      <div>
                        <div className="custom-control custom-radio custom-control-inline">
                          <input
                            type="radio"
                            id="vms-button-1"
                            name="vms"
                            className="custom-control-input"
                            value="true"
                            checked={this.state.access_vms === true}
                            onChange={() =>
                              this.handleChangeComapny('access_vms', true)
                            }
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="vms-button-1"
                          >
                            Yes
                          </label>
                        </div>
                        <div className="custom-control custom-radio custom-control-inline">
                          <input
                            type="radio"
                            id="vms-button-2"
                            name="vms"
                            className="custom-control-input"
                            value="false"
                            checked={this.state.access_vms === false}
                            onChange={() =>
                              this.handleChangeComapny('access_vms', false)
                            }
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="vms-button-2"
                          >
                            No
                          </label>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              
            </Accordion.Body>
          </Accordion.Item>
        )}

        {/* ─────────────────────────────────────────────── */}
        {/* ADDITIONAL DETAILS                                */}
        {/* ─────────────────────────────────────────────── */}
        <Accordion.Item eventKey="2">
          <Accordion.Header>Additional Details</Accordion.Header>
          <Accordion.Body>

            {UserObj?.company_id != process.env.REACT_APP_TALBOT_COM_ID &&
              UserObj?.company_id != process.env.REACT_APP_PROZO_COM_ID ? (
              <div className="row">
                <div className="col-md-8 col-xs-12 col-sm-8">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">
                      Last Active On App
                    </label>
                    <SwInput
                      type="text"
                      value={
                        this.state.lastActivity == null
                          ? ''
                          : moment
                            .unix(this.state.lastActivity)
                            .format('YYYY-MM-DD HH:mm:ss')
                      }
                      disabled
                    />
                  </div>
                </div>
              </div>
            ) : (
              ''
            )}

            <div className="row ">
              <div className="col-md-12 col-xs-12 col-sm-6">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">Vaccinated</label>
                  <div>
                    <SwRadio
                      id="vaccinatedYes"
                      name="vaccinated"
                      label="Yes"
                      inline
                      checked={this.state.vaccinated === true}
                      onChange={() => this.setState({ vaccinated: true })}
                    />
                    <SwRadio
                      id="vaccinatedNo"
                      name="vaccinated"
                      label="No"
                      inline
                      checked={this.state.vaccinated === false}
                      onChange={() =>
                        this.setState({ vaccinated: false })
                      }
                    />
                  </div>
                </div>
              </div>
              <span className="SwTextDanger SwTextSmall">
                {this.state.vaccinatederrorMsg}
              </span>
            </div>
            {this.state.vaccinated === true && (
              <div className="row">
                <div className="col-md-12 col-xl-8 col-lg-8">
                  <div className="formAddmemGrid">
                    <label>Upload Certificate*</label>
                  <AntDUpload
  type="button"
  listType="text"
  fileList={this.state.certificateFileList || []}
  accept="image/*,.pdf"
  maxFiles={1}
  maxSizeMB={5}
  autoUpload={false}
onChange={({ fileList }) => {
  this.setState({ certificateFileList: fileList });

  if (fileList.length > 0) {
    const fileObj = fileList[0].originFileObj;

    if (fileObj) {
      const fakeEvent = { target: { files: [fileObj] } };
      this.uploadImgfile2(fakeEvent);
    }
  } else {
    // 🔥 When file removed
    this.setState({
      certificate: '',
      certificateFile: '',
    });
  }
}}
>
  <SwButton variant="primary">
    <i className="fa fa-upload" /> Upload Certificate
  </SwButton>
</AntDUpload>
                    <p
                      style={{
                        'font-size': '12px',
                        'margin-top': '5px',
                      }}
                    >
                      {this.state.vaccinatedtype.map(item => {
                        if (item.isActive === true) {
                          return item.vacFile;
                        }
                      })}
                    </p>
                  </div>
                </div>
             
              </div>
            )}

            <div className="row">
              <div className="col-md-8 col-xs-12 col-sm-8">
                <div className="SwFormGroup font14">
                  <label className="SwFormLabel">Blood Group</label>

                  <SwSelect
                    options={this.bloodGroupOptions}
                    value={
                      this.bloodGroupOptions.find(
                        option => option.value === this.state.blood_group,
                      ) || null
                    }
                    onChange={this.changeBldGroup}
                    placeholder="Select Blood Group"
                    isClearable={false}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-8 col-xs-12 col-sm-8">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">
                    Emergency Contact Number
                  </label>
                  <SwInput
                    type="text"
                    name="emergency_contact"
                    value={this.state.emergency_contact}
                    onChange={this.EditMemeberHandler}
                    placeholder="Enter Emergency Contact Number"
                    maxLength={10}
                    onKeyPress={restrictEqualSign}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 col-xl-12 col-lg-12">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">Address</label>
                  <SwTextArea
                    name="address"
                    value={this.state.address}
                    onChange={this.EditMemeberHandler}
                    placeholder="Enter Address"
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 col-xl-12 col-lg-12">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">Date of Birth</label>

                  <AntDDatePicker
                    name="dob"
                    value={
                      this.state.dob && dayjs(this.state.dob).isValid()
                        ? dayjs(this.state.dob)
                        : null
                    }
                    onChange={date =>
                      this.setState({
                        dob: date ? date.format('YYYY-MM-DD') : '',
                      })
                    }
                    format="DD/MM/YYYY"
                    placeholder="Select Date of Birth"
                  />
                </div>
              </div>
            </div>

      {/* KYC Dropdown Row */}
<div className="row">
  <div className="col-md-12 col-xs-12 col-sm-6">
    <div className="SwFormGroup">
      <label className="SwFormLabel">KYC Proof</label>

      <SwSelect
        options={this.kycOptions}
        value={
          this.kycOptions.find(
            option => option.value === this.state.kyc_type
          ) || null
        }
        onChange={this.changeKycType}
        placeholder="Select KYC Proof"
        isClearable={false}
      />
    </div>
  </div>
</div>

{/* Upload Row (Like Vaccinated) */}
{this.state.kyc_type && (
  <div className="row">
    <div className="col-md-12 col-xl-8 col-lg-8">
      <div className="formAddmemGrid">
        <label className="SwFormLabel d-block">Upload KYC*</label>

        <AntDUpload
          type="button"
          listType="text"
          fileList={this.state.kycFileList || []}
          accept="image/*,.pdf"
          maxFiles={1}
          maxSizeMB={5}
          autoUpload={false}
          onChange={({ fileList }) => {
            this.setState({ kycFileList: fileList });

            if (fileList.length > 0) {
              const fileObj = fileList[0].originFileObj;

              if (fileObj) {
                this.setState({
                  kyc: fileObj,
                  fileName1: fileObj.name,
                });

                this.uploadImgfile({
                  target: { files: [fileObj] },
                });
              }
            } else {
              this.setState({
                kyc: "",
                fileName1: "",
              });
            }
          }}
        >
          <SwButton variant="primary">
            <i className="fa fa-upload" /> Upload KYC
          </SwButton>
        </AntDUpload>

        {this.state.fileName1 && (
          <p
            style={{
              fontSize: "12px",
              marginTop: "5px",
            }}
          >
            {this.state.fileName1}
          </p>
        )}
      </div>
    </div>
  </div>
)}
            <div className="row">
              <div className="col-md-12 col-xl-12 col-lg-12">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">Gender</label>
                  <SwSelect
                    name="gender"
                    value={
                      [
                        { value: 'MALE', label: 'Male' },
                        { value: 'FEMALE', label: 'Female' },
                        { value: 'OTHER', label: 'Others' },
                      ].find(opt => opt.value === this.state.gender) ||
                      null
                    }
                    onChange={selectedOption =>
                      this.setState({
                        gender: selectedOption?.value,
                      })
                    }
                    options={[
                      { value: 'MALE', label: 'Male' },
                      { value: 'FEMALE', label: 'Female' },
                      { value: 'OTHER', label: 'Others' },
                    ]}
                    placeholder="Select Gender"
                    isClearable={false}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 col-xl-12 col-lg-12">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">Specially abled</label>

                  <SwSelect
                    options={this.speciallyAbledOptions}
                    value={
                      this.speciallyAbledOptions.find(
                        option =>
                          option.value === this.state.specially_abled,
                      ) || null
                    }
                    onChange={this.changespecAbled}
                    placeholder="Select"
                    isClearable={false}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 col-xl-12 col-lg-12">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">Date of Joining</label>

                  <AntDDatePicker
                    name="date_of_joining"
                    value={
                      this.state.date_of_joining
                        ? dayjs(this.state.date_of_joining)
                        : null
                    }
                    onChange={date =>
                      this.setState({
                        date_of_joining: date
                          ? date.format('YYYY-MM-DD')
                          : '',
                      })
                    }
                    format="DD/MM/YYYY"
                    placeholder="Select Date of Joining"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 col-xl-12 col-lg-12">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">Designation</label>
                  <SwInput
                    type="text"
                    name="designation"
                    value={this.state.designation}
                    onChange={this.addMemeberHandler}
                    placeholder="Enter Designation"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 col-xl-12 col-lg-12">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">Payroll Vendor</label>
                  <SwInput
                    type="text"
                    name="payroll"
                    value={this.state.payroll}
                    onChange={this.addMemeberHandler}
                    placeholder="Enter Payroll Vendor"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 col-xl-12 col-lg-12">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">Project</label>
                  <SwInput
                    type="text"
                    name="project"
                    value={this.state.project}
                    onChange={this.addMemeberHandler}
                    placeholder="Enter Project"
                  />
                </div>
              </div>
            </div>

          </Accordion.Body>
        </Accordion.Item>

      </Accordion>

        {/* Modal Grant */}
        <SwModal
          show={showGrant}
          onClose={this.handleCloseGrant}
          className="sw-small-modal"
          footer={
            <div className="d-flex justify-content-center gap-3">
              <SwButton
                variant="dark-outline"
                size="sm"
                onClick={this.handleCloseGrant}
              >
                Cancel
              </SwButton>

              <SwButton variant="primary" size="sm" onClick={this.GrantAccess}>
                Grant Access
              </SwButton>
            </div>
          }
        >
          <SwButton
            variant=""
            className="btn-close btn-close-custom"
            onClick={this.handleCloseGrant}
          />
          <h3 className="SwModalSubHeading">
            Grant site access for this user?
          </h3>
          <p className="mb-1">You are about to grant access.</p>
        </SwModal>

        {/* Modal Revoke */}
        <SwModal
          show={showRevoke}
          onClose={this.handleCloseRevoke}
          className="sw-small-modal"
          footer={
            <div className="d-flex justify-content-center gap-3">
              <SwButton
                variant="dark-outline"
                size="sm"
                onClick={this.handleCloseRevoke}
              >
                Cancel
              </SwButton>

              <SwButton variant="danger" size="sm" onClick={this.DenyRequest}>
                Revoke Access
              </SwButton>
            </div>
          }
        >
          <SwButton
            variant=""
            className="btn-close btn-close-custom"
            onClick={this.handleCloseRevoke}
          />
          <h3 className="SwModalSubHeading">
            Revoke site access for this user?
          </h3>
          <p className="mb-1">
            Are you sure you want to revoke access of this user?
          </p>
        </SwModal>

        {/* Modal revoke-deny */}
        <SwModal
          show={showDeny}
          onClose={this.handleCloseDeny}
          className="sw-small-modal"
          footer={
            <div className="d-flex justify-content-center gap-3">
              <SwButton
                variant="dark-outline"
                size="sm"
                onClick={this.handleCloseDeny}
              >
                Cancel
              </SwButton>

              <SwButton variant="danger" size="sm" onClick={this.DenyRequest}>
                Deny Access
              </SwButton>
            </div>
          }
        >
          <SwButton
            variant=""
            className="btn-close btn-close-custom"
            onClick={this.handleCloseDeny}
          />
          <h3 className="SwModalSubHeading">Deny Request?</h3>
          <p className="mb-1">
            Are you sure you want to deny this user's request?
          </p>
        </SwModal>

        {/* Modal Reject FR Image */}
        <SwModal
          show={this.state.showRejectFr}
          onClose={this.handleCloseRejectFr}
          className="sw-small-modal"
          footer={
            <div className="d-flex justify-content-center gap-3">
              <SwButton
                variant="dark-outline"
                size="sm"
                onClick={this.handleCloseRejectFr}
              >
                Cancel
              </SwButton>

              <SwButton
                variant="danger"
                size="sm"
                onClick={this.handleRejectFrImage}
              >
                Reject
              </SwButton>
            </div>
          }
        >
          <SwButton
            variant=""
            className="btn-close btn-close-custom"
            onClick={this.handleCloseRejectFr}
          />
          <h3 className="SwModalSubHeading">Reject FR Image?</h3>
          <div className="SwFormGroup">
            <label className="SwFormLabel">
              Rejection Reason
              <span className="Required">*</span>
            </label>
            <SwTextArea
              name="rejectFrReason"
              value={this.state.rejectFrReason}
              onChange={this.onRejectFrReasonChange}
              placeholder="Enter the reason for rejecting this FR image"
            />
          </div>
        </SwModal>

        {/* Modal Delete user */}
        <SwModal
          show={showDelUser}
          onClose={this.handleCloseDelUser}
          className="sw-small-modal"
          footer={
            <div className="d-flex justify-content-center gap-3">
              <SwButton
                variant="dark-outline"
                size="sm"
                onClick={this.handleCloseDelUser}
              >
                Cancel
              </SwButton>

              <SwButton
                variant="primary"
                size="sm"
                onClick={() => this.deleteUser()}
              >
                Confirm
              </SwButton>
            </div>
          }
        >
          {' '}
          <SwButton
            variant=""
            className="btn-close btn-close-custom"
            onClick={this.handleCloseDelUser}
          />
          <h3 className="SwModalSubHeading">Alert!!</h3>
          <p className="mb-1">
            Are you sure you want to delete this user's request?
          </p>
        </SwModal>
      </>
    );
  }
}

// const mapStateToProps = state => ({
//   EditUserList: state.activeUserList,
//   ActiveDataUPload: state.activeUserList.AcitvmemberListEdit,
//   newMemberData: state.activeUserList,
//   CityData: state.activeUserList,
// });

const mapStateToProps = state => {
  return {
    EditUserList: state.activeUserList,
    ActiveDataUPload: state.activeUserList.AcitvmemberListEdit,
    newMemberData: state.activeUserList,
    CityData: state.activeUserList,
    CityData1: state.activeUserList,
    buildingInfo: state.activeUserList.CityData,
    BuildingSPOCData: state.activeUserList.BuildingSPOCData,
  };
};

const mapActionsToProps = {
  grantAccess1,
  grantAccess,
  editformMember,
  allMember,
  onCityLocation,
  onBuildingLocation,
  onBuildingLocation1,
  onSPOCLocation,
};
const AddnewMemberWithRef = forwardRef((props, ref) => (
  <AddnewMember {...props} ref={ref} />
));

export default connect(
  mapStateToProps,
  mapActionsToProps,
  null,
  { forwardRef: true }, // ⭐ STILL REQUIRED
)(AddnewMemberWithRef);
